/** Canonical pure semantics, shared by the host and native editor. */



/**
 * 🧩 제로폭 문자 제거(SSOT) — 빈 씬 자리표시자(EMPTY_SCENE_PLACEHOLDER = U+200B)는 씬 경계로
 * 인정받으려고 일부러 `trim()` 대상이 아닌 문자를 쓴다(story-data-edit 주석 참조). 그래서 자막
 * 텍스트를 ★사람이 읽는 값★으로 소비하는 하류(이미지 프롬프트·노드 나레이션/제목 등)는 반드시
 * 이걸 통과시켜야 한다 — 안 그러면 눈에 안 보이는 문자가 프롬프트·나레이션으로 새 나간다.
 * ★씬 경계 판정(meaningfulLines)에는 쓰지 않는다★ — 거기선 자리표시자가 살아 있어야 씬이 성립한다.
 */
export const stripZeroWidth = (s?: string | null): string => String(s ?? "").replace(/[​-‍﻿]/g, "");
